<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>รายการ Export ล่าสุด</strong></v-card-title>
          </v-layout>
          <br />
        <v-layout row wrap justify-center align-end>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md3 lg3 px-3>
                <p style="color:#4C4C4C; font-size:90%;"><strong>วันที่ Export</strong></p>
                <VueCtkDateTimePicker color="#F06292" :no-value-to-custom-elem="true" v-model="exportdatepicker" only-date range v-on:input="daterangefunction(exportdatepicker)">
                  <v-text-field v-model="exportdateview" outlined dense color="pink lighten-3" readonly v-on:input="orderfilterfunction()"></v-text-field>
                </VueCtkDateTimePicker>
              </v-flex>
            </v-layout>
            <br />
          <v-data-table
            :headers="headers"
            :items="orderdatas"
            :items-per-page="10"
            class="elevation-3"
            :loading="loading"
            :server-items-length="datalength"
            @update:page="pagechange"
            @update:items-per-page="itempagechange"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openorderdetail(item._id)">{{ item.order_no }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.username }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.order_date_th }}</td>
                  <td @click="openorderdetail(item._id)">{{ item.delivery_date_th }}</td>
                  <td @click="openorderdetail(item._id)">
                    <v-chip
                      :color="getColor(item.order_status)"
                      text-color="white"
                    >{{ item.order_status_th }}
                    </v-chip>
                  </td>
                  <td @click="openorderdetail(item._id)">
                    <v-chip
                      :color="getColor(item.payment_status)"
                      outlined
                    >{{ item.payment_status_th }}
                    </v-chip>
                  </td>
                  <td @click="openorderdetail(item._id)">{{ item.export_date_th }}</td>
                  <td>
                    <v-icon meduim @click="exportagain(item._id)">mdi-publish mdi-flip-v</v-icon>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        </v-card>
      </v-flex>
      <Orderdetailmodal />
    </v-layout>
  </v-container>
</template>

<script>
import Orderdetailmodal from '@/components/Orderdetailmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import { Parser } from 'json2csv'
import moment from 'moment'
moment.locale('th')
export default {
  components: {
    Orderdetailmodal
  },
  data: () => ({
    headers: [
      { text: 'เลขที่เอกสาร', align: 'center', sortable: false, value: 'order_no' },
      { text: 'รหัสร้านค้า', align: 'center', sortable: false, value: 'username' },
      { text: 'วันที่สั่ง', align: 'center', sortable: false, value: 'order_date_th' },
      { text: 'จัดส่งวันที่', align: 'center', sortable: false, value: 'delivery_date_th' },
      { text: 'สถานะ', align: 'center', sortable: false, value: 'order_status' },
      { text: 'การชำระเงิน', align: 'center', sortable: false, value: 'payment_status' },
      { text: 'วันที่ Export', align: 'center', sortable: false, value: 'export_date_th' },
      { text: 'Export อีกครั้ง', value: 'action', sortable: false, align: 'center' }
    ],
    orderdatas: [],
    orderdata_view: [],
    name_search: '',
    username_search: '',
    searchitems: [
      { text: 'เจ้าหน้าที่ผู้ดูแล', items: [], itemtext: 'adminref_name', model: [] },
      { text: 'สถานะ', items: ['จัดส่งสำเร็จ', 'จัดส่งไม่สำเร็จ', 'ไม่อนุมัติ'], itemtext: 'order_status_th', model: [] },
      { text: 'การชำระเงิน', items: ['อนุมัติ', 'ไม่อนุมัติ', 'ไม่ต้องชำระ'], itemtext: 'payment_status_th', model: [] }
    ],
    loading: false,
    page: 1,
    itempage: 10,
    exportdatepicker: '',
    exportdateview: '',
    datalength: 0
  }),
  created () {
    var date = new Date()
    var enddate = date.toISOString().split('T')[0]
    date.setDate(date.getDate() - 30)
    var startdate = date.toISOString().split('T')[0]
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin' || this.$cookies.get('status') === 'admin') {
        this.getdata(startdate, enddate)
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    pagechange (p) {
      this.page = p
      this.getdata()
    },
    itempagechange (itp) {
      this.itempage = itp
      this.getdata()
    },
    getColor (status) {
      if (status === '00') return 'info'
      else if (status === '01') return 'success'
      else if (status === '02') return '#DD4B39'
      else if (status === '10') return '#52B9EB'
      else if (status === '11') return '#F7BA38'
      else if (status === '12') return '#388E3C'
      else if (status === '13') return '#F23B22'
      else if (status === '0') return 'info'
      else if (status === '1') return 'warning'
      else if (status === '2') return 'success'
      else if (status === '3') return '#DD4B39'
      else if (status === '4') return '#000000'
    },
    changestatustocode (statusarr) {
      let result = statusarr.map(status => {
        let codestt = ''
        if (status === 'จัดส่งสำเร็จ') {
          codestt = '12'
        } else if (status === 'จัดส่งไม่สำเร็จ') {
          codestt = '13'
        } else if (status === 'ไม่อนุมัติ') {
          codestt = '02'
        } else if (status === 'อนุมัติ') {
          codestt = '2'
        } else if (status === 'ไม่อนุมัติ') {
          codestt = '3'
        } else if (status === 'ไม่ต้องชำระ') {
          codestt = '4'
        }
        return codestt
      })
      return result
    },
    async getdata (stdate, endate) {
      try {
        // this.loading = true
        this.exportdateview = stdate && endate ? `${stdate} ~ ${endate}` : this.exportdateview
        let { data } = await axios.get(`${process.env.VUE_APP_API}/order/get/export`, {
          headers: {
            Authorization: this.$cookies.get('token'),
            limit: this.itempage,
            skip: (Number(this.page) - 1) * Number(this.itempage),
            exportdate: this.exportdateview
          }
        })

        this.orderdatas = data.orderdata.map((pd, index) => {
          pd.payment_status_th = pd.payment_status === '1' ? 'ชำระแล้ว' : pd.payment_status === '2' ? 'อนุมัติ' : pd.payment_status === '3' ? 'ไม่อนุมัติ' : pd.payment_status_th
          return {
            ...pd,
            order_date_th: moment(pd.order_date).format('ll'),
            delivery_date_th: pd.delivery_date ? moment(pd.delivery_date).format('ll') : '',
            export_date_th: pd.export_date ? moment(pd.export_date).format('lll') : ''
          }
        })
        this.datalength = Number(data.orderlength)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    openneworder () {
      this.$router.push('/orderdetail')
    },
    openorderdetail (id) {
      this.orderdetailmodal = true
      this.currentorderid = id || ''
      this.orderdetailmode = 1
    },
    daterangefunction (datepicker) {
      this.exportdateview = `${datepicker.start.split(' ')[0]} ~ ${datepicker.end ? datepicker.end.split(' ')[0] : datepicker.start.split(' ')[0]}`
      this.getdata()
    },
    orderfilterfunction () {
      this.getdata()
    },
    exportagain (id) {
      let orderexport = this.orderdatas.find(od => od._id === id)
      let header = this.csvheader
      let result = []
      let newdate = `${(orderexport.delivery_date.split('T')[0]).split('-')[2]}/${orderexport.delivery_date.split('-')[1]}/${orderexport.delivery_date.split('-')[0]}`
      orderexport.productitems.forEach(product => {
        let resultdata = {
          'วันที่เอกสาร': newdate,
          'เลขที่เอกสาร': orderexport.order_no,
          'วันที่ใบกำกับภาษี': '',
          'เลขที่ใบกำกับภาษี': '',
          'รหัสลูกหนี้/เจ้าหนี้': orderexport.username,
          'รหัสซื้อขาย': product.product_no,
          'จำนวนสินค้า': product.quantity,
          'จำนวนแถม': '',
          'ราคาต่อหน่วย': product.price,
          'ส่วนลดต่อรายการ': '',
          'ตน.เก็บ': '156',
          'ตน.เก็บโอนย้าย': '',
          'ส่วนลดท้ายบิล': '',
          'หมายเหตุท้ายบิล': ''
        }
        result.push(resultdata)
      })
      const json2csvParser = new Parser({ quote: '' })
      const csv = json2csvParser.parse(result, { header })
      const crrdate = new Date()
      var downloadLink = document.createElement('a')
      var blob = new Blob(['\ufeff', csv])
      var url = URL.createObjectURL(blob)
      downloadLink.href = url
      downloadLink.download = `${orderexport.order_no}_ae${crrdate.toISOString().split('T')[0]}.csv`
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    }
  },
  computed: {
    orderdetailmodal: sync('orderdetailmodal'),
    currentorderid: sync('currentorderid'),
    orderdetailmode: sync('orderdetailmode')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}

.v-data-table {
  font-family: 'Kanit';
}

td {
  max-width: 130px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>

<style>
.date-time-picker * {
  font-family: 'Kanit' !important;
}
</style>
